/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getSessionStorage } from "./utils";
import Alert from "./Components/AlertPopup";
import { useSessionExpiry } from './hooks/useSessionExpiry';

interface PrivateRouteProps {
  element: React.FC;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element: Element }) => {
  const user = getSessionStorage("user");
  const [offlineAlert, setOfflineAlert] = useState(false);
  const [serverAlert, setServerAlert] = useState(false);

  // FIX: Move hook to top level - never call hooks inside event handlers
  useSessionExpiry();

  useEffect(() => {
    let offlineHandled = false; // Guard to prevent multiple alerts

    const handleOffline = () => {
      if (offlineHandled) return; // Prevent multiple firings
      offlineHandled = true;

      sessionStorage.setItem("offlineError", "true");
      setOfflineAlert(true);
    };

    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    let serverHandled = false; // Guard to prevent multiple alerts

    const showServerDown = () => {
      if (serverHandled) return; // Prevent multiple firings
      serverHandled = true;

      setServerAlert(true);
    };

    window.addEventListener("server-down-error", showServerDown);

    return () => {
      window.removeEventListener("server-down-error", showServerDown);
    };
  }, []);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {offlineAlert && (
        <Alert
          type="error"
          show={true}
          title="Connection Error"
          message="Unable to connect. Verify your internet connection."
          onClose={() => setOfflineAlert(false)}
        />
      )}
      {serverAlert && (
        <Alert
          type="error"
          show={true}
          title="Server Unavailable"
          message="The server is currently unreachable. Please try again later."
          onClose={() => setServerAlert(false)}
        />
      )}

      <Element />
    </>
  );
};

export default PrivateRoute;
